import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function contrato(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@contrato/FIND_CONTRATO':
      case '@contrato/UPDATE_CONTRATO':
      case '@contrato/DELETE_CONTRATO':
      case '@contrato/STORE_CONTRATO':
      case '@contrato/CONTRATOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@contrato/SUCCESS_REMOVE':
      case '@contrato/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@contrato/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.contratos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@contrato/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.contrato;
        break;
      }

      case '@contrato/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
